module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "question"
    }
  }, [_c('layout'), _vm._v(" "), (_vm.question === undefined) ? _c('div', [_c('form', [_c('h1', [_vm._v("Category")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h1', [_vm._v("Difficulty")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', [_c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.getQuestion
    }
  }, [_vm._v("Get Question")])])])]) : _c('div', [_vm._v("\n        " + _vm._s(_vm.question) + "\n\n        "), _c('br'), _vm._v(" "), _vm._l((_vm.answers), function(answer) {
    return _c('p', [_c('button', {
      on: {
        "click": _vm.sendAnswer
      }
    }, [_vm._v(_vm._s(answer))])])
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "green-banner"
    }
  }, [_c('div', {
    attrs: {
      "id": "success"
    }
  }, [_vm._v("SUCCESS")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "safe"
    }
  }, [_vm._v("Your followers won't know you're dumb......")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "fornow"
    }
  }, [_vm._v("for now.")])])], 2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "score"
    }
  }, [_vm._v("SCORE:"), _c('br'), _vm._v(_vm._s(_vm.score))])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    attrs: {
      "id": "categorySelect"
    }
  }, [_c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("General Knowledge")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("Entertainment: Books")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("Entertainment: Film")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("Entertainment: Music")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "13"
    }
  }, [_vm._v("Entertainment: Musicals & Theatres")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14"
    }
  }, [_vm._v("Entertainment: Television")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v("Entertainment: Video Games")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "16"
    }
  }, [_vm._v("Entertainment: Board Games")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "17"
    }
  }, [_vm._v("Science & Nature")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18"
    }
  }, [_vm._v("Science: Computers")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "19"
    }
  }, [_vm._v("Science: Mathematics")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("Mythology")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "21"
    }
  }, [_vm._v("Sports")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "22"
    }
  }, [_vm._v("Geography")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "23"
    }
  }, [_vm._v("History")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "24"
    }
  }, [_vm._v("Politics")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("Art")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "26"
    }
  }, [_vm._v("Celebrities")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "27"
    }
  }, [_vm._v("Animals")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "28"
    }
  }, [_vm._v("Vehicles")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "29"
    }
  }, [_vm._v("Entertainment: Comics")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "30"
    }
  }, [_vm._v("Science: Gadgets")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "31"
    }
  }, [_vm._v("Entertainment: Japanese Anime & Manga")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "32"
    }
  }, [_vm._v("Entertainment: Cartoon & Animations")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    attrs: {
      "id": "difficultySelect"
    }
  }, [_c('option', [_vm._v("Easy")]), _vm._v(" "), _c('option', [_vm._v("Medium")]), _vm._v(" "), _c('option', [_vm._v("Hard")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d27e1792"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Question.vue
// module id = 92
// module chunks = 0